import { Checkbox } from "./ui/Checkbox";
import { cn } from "../../utils/cn";
import { useRefinementList } from "react-instantsearch";

export type RefinementListToggleProps = {
    className: string,
    children: any,
    attribute: string,
    value: string, // Single value to toggle
};

export default function RefinementListToggle({ className, children, attribute, value }: RefinementListToggleProps) {
    // Each component gets its own completely independent useRefinementList
    const { items, canRefine, refine } = useRefinementList({ 
        attribute,
        limit: 100  // allow multiple instances to work independently
    });

    // Find the specific item we're interested in
    const targetItem = items.find(item => item.value === value);
    const isRefined = targetItem?.isRefined || false;
    
    const handleToggle = () => {
        if (targetItem) {
            refine(targetItem.value);
        }
    };

    const isDisabled = !canRefine || !targetItem;

    return (
        <label className={cn(
            isDisabled && "tw-cursor-not-allowed tw-opacity-50",
            className
        )}>
            {children}

            <Checkbox
                checked={isRefined}
                disabled={isDisabled}
                onCheckedChange={handleToggle}
                className={cn(
                    "tw-h-4 tw-w-4 tw-border-black tw-text-white tw-mr-2",
                    !canRefine && "tw-cursor-not-allowed",
                )}
            />
        </label>
    )
}